<template>
  <div class="main-chapter1">
    <n-loader :loading="$var('load')" />
    <n-items v-if="project">
      <n-input :title="'В журнале '+ $form.get('pageCount') + ' листов, пронумеровано и скреплено печатью.'" v-bind="$form.input('pageCount')" :text="!editable" />
      <n-input title="Главный инженер" v-bind="$form.input('engineer')" :text="!editable" />
      <div>УДК МКС</div>
      <div>Ключевые слова: высоковольтные линии, открытое распределительное устройство,<br> охрана труда, пусконаладочные работы, проект организации строительства, проект<br> производства работ, правила техники безопасности, правила технической эксплуатации,<br> пусковые работы, распределительные устройства, техника безопасности,<br> электромонтажные работы</div>
      <n-button v-if="editable" color="success" @click="submit">Сохранить</n-button>
    </n-items>
  </div>
</template>

<script>
export default {
  name: 'MainChapter1',
  props: {
    project: { type: Object, default: () => ({}), },
    journal: { type: Object, default: () => ({}), },
    editable: { type: Boolean, default: false, },
  },
  data: () => ({
  }),
  created() {
    this.$form.init(this.journal.data)
  },
  methods: {
    submit() {
      this.$var('load', true)
      $api.journals.edit(this.project.id, this.journal.name, this.$form.get()).then(() => {
        this.$emit('reload')
      }).finally(() => {
        this.$var('load', false)
      })
    },
  },
}
</script>

<style lang="scss" scoped>
  .main-chapter1 {
  
  }
</style>
